module.exports = __webpack_public_path__ + "static/media/emli.18655553.png";